<script>
import baseMixin from '@/mixins/baseMixin'
import CommentModel from '@/models/comments/commentModel'
import CommentControl from './comment-control.vue'

export default {
  name: 'CommentList',
  components: { CommentControl },
  mixins: [baseMixin],
  props: {
    title: {
      type: String,
      default: 'Comments',
    },
    comments: {
      type: Array,
      default: () => [],
      validator: (list) => list.every((e) => e instanceof CommentModel),
    },
  },
}
</script>

<template>
  <div>
    <slot name="title" :title="title">
      <h6 class="text-h6">{{ title }}</h6>
    </slot>

    <slot name="prepend"></slot>
    <div class="mt-4">
      <CommentControl
        v-for="comment of comments"
        :key="comment.id"
        :comment="comment"
        class="mb-4"
      />
    </div>
    <slot name="append"></slot>
  </div>
</template>
